import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '../../components/ui/dialog';
import AuthFirstSalesPage from './AuthFirstSalesPage';

type AuthFirstDialogProps = {
  analyticsContext?: Record<string, unknown>;
  entryMode?: 'discovery' | 'checkout' | 'login' | 'signup';
  onAuthenticated?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  returnTo: string;
};

const AuthFirstDialog = ({
  analyticsContext,
  entryMode = 'discovery',
  onAuthenticated,
  onOpenChange,
  open,
  returnTo,
}: AuthFirstDialogProps): React.ReactElement => {
  const contentRef = useRef<HTMLDivElement>(null);
  const title = entryMode === 'checkout'
    ? 'Create or sign in to continue to checkout'
    : entryMode === 'login'
      ? 'Sign in to BotSpot'
      : 'Create your BotSpot account';
  const description = entryMode === 'checkout'
    ? 'Use Google or email. Your plan selection is saved.'
    : entryMode === 'login'
      ? 'Use Google or email.'
      : 'Use Google or email.';

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className="auth-first-dialog-content"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          contentRef.current?.focus({ preventScroll: true });
        }}
        ref={contentRef}
        tabIndex={-1}
      >
        <DialogTitle className="bsui-sr-only">{title}</DialogTitle>
        <DialogDescription className="bsui-sr-only">{description}</DialogDescription>
        <AuthFirstSalesPage
          analyticsContext={analyticsContext}
          entryMode={entryMode}
          onAuthenticated={onAuthenticated}
          presentation="overlay"
          returnTo={returnTo}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AuthFirstDialog;
